import { Environment } from '../../environments/types';
import { isKubernetesEnvironment } from '../../environments/utils';

export function getRegistryPolicy(environment?: Environment) {
  if (!environment) {
    return undefined;
  }
  // for kube orchestrator, get the k8sRegistryPolicy
  if (isKubernetesEnvironment(environment.Type)) {
    return environment.Policies?.k8sRegistryPolicy;
  }
  // otherwise get the dockerRegistryPolicy
  return environment.Policies?.dockerRegistryPolicy;
}
